/* @ngInject */
function ManageAssetsTabGeneralController ($scope, $q, $translate, $rootScope, $timeout, UdsModalService) {
  const getCreateTagController = () => $q.when(import('../../../admin/dialogs/create-tag/create-tag.controller'))
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))

  const api = {
    getCreateTagController,
    getUpgradeCompanyPlanDialogController
  }
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.onChangeName = (event) => {
    if (event?.detail?.value !== $scope.form.name) {
      $scope.flags.hasSave = false
      $scope.form.name = event.detail.value
    }
  }

  $scope.onChangeTags = (event) => {
    $scope.flags.hasSave = false

    if (!event.detail?.length) {
      $scope.form.tags = []
      return
    }

    $scope.form.tags = event.detail
  }

  $scope.onSearchTags = (event) => {
    const search = event.detail?.search || ''
    $scope.tagsPagination.skip = 0

    $scope.getAllTags({ search: search, firstLoad: true })
  }

  $scope.onInfiniteLoadTags = (event) => {
    const search = event.detail?.search || ''
    $scope.tagsPagination.skip += $scope.tagsPagination.top

    $scope.getAllTags(search, false)
  }

  $scope.createTag = () => {
    api.getCreateTagController().then(({ CreateTagController }) => {
      const createTag = UdsModalService.createModal({
        controller: CreateTagController,
        modalName: 'createTag',
        data: {
          flag: 'create',
          location: 'repository'
        },
        onClose: (returnData) => {
          if (returnData?.success && returnData?.createdTag) {
            $timeout(() => {
              $scope.tagsOptions = [...$scope.tagsOptions, {
                label: returnData.createdTag.name,
                value: returnData.createdTag.id
              }]
            })
          }
        }
      })

      createTag.open()
    })
  }

  $scope.changeApplyTagsToAllAssets = (event) => {
    const value = event?.detail?.value
    $scope.flags.applyTagsToAllAssets = !!value
    $scope.flags.hasSave = false
  }

  $scope.onClickTagsInput = () => {
    if (!$scope.tagsPricingDisabled) {
      return
    }

    $rootScope.getCompanyWithBillingPackage().then((companyBillingPackage) => {
      const isLegacy = Boolean(companyBillingPackage?.billingPackage?.plan?.pricingPackage?.legacy)

      if (!isLegacy) {
        return api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
          const modal = UdsModalService.createModal({
            controller: UpgradeCompanyPlanDialogController,
            modalName: 'upgradeCompanyPlanDialog',
            data: {
              featureName: $translate.instant('tags'),
              featureSlug: 'REPOSITORIES.TAGS'
            }
          })

          modal.open()
        })
      }
    })
  }
}

export { ManageAssetsTabGeneralController }
